export const SelectIconStyle = {
  selectedIcon: {
    style: {
      overflow: 'hidden',
      maxHeight: 50,
      fontSize: 12,
    },
  },
  box: {
    style: {
      display: 'flex',
      cursor: 'pointer',
    },
  },
  icon: {
    style: {
      marginLeft: '10px',
    },
    sx: {
      color: 'text.secondary',
    },
  },
  dialogTitle: {
    sx: {
      backgroundColor: 'primary.main',
      color: 'white',
    },
    style: {
      display: 'flex',
    },
  },
  close: {
    marginLeft: 'auto',
    cursor: 'pointer',
  },
};

export const styleTalentDetails = {
  cardContent: {
    form: {
      width: '100%',
      boxLabel: {
        xs: 3,
      },
      boxInput: {
        xs: 8,
      },
      boxIcon: {
        xs: 1,
        textAlign: 'end',
        box: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          height: '31px',
        },
        boxAddnew: {
          textAlign: 'end',
          mr: 2,
        },
        checkCircle: {
          color: '#EC0982',
        },
      },
      box: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '15px',
        '&:hover': {
          backgroundColor: 'rgba(80, 72, 229, 0.08);',
        },
      },
      error: {
        color: 'error.main',
        variant: 'caption',
        backgroundColor: 'rgba(209, 67, 67, 0.12)',
        sx: {
          ml: 2,
        },
        dividerError: {
          border: '1px solid #D14343',
        },
      },
      InputLabel: {
        width: '220px',
        paddingLeft: '15px',
        fontWeight: '600',
        color: '#130F35',
      },
      TextField: {
        backgroundColor: 'none',
        display: 'flex',
        alignItems: 'center',
        color: '#6B7280',
      },
      CardContent: {
        removePB: {
          paddingBottom: '0px',
        },
        sx: {
          p: 0,
          mx: 0,
        },
      },
    },
  },
} as const;

const iconSize = {
  width: '28px',
  height: '28px',
};

export const rowStyle = {
  iconWrapper: {
    style: {
      display: 'flex',
      cursor: 'pointer',
    },
  },
  xCircleIcon: {
    style: {
      color: '#9CA3AF',
      ...iconSize,
    },
  },
  plusIcon: {
    style: {
      ...iconSize,
    },
  },
};
